module.exports = __webpack_public_path__ + "components/country-flag/static/bs-0d9d351c7e23fa8536044eab8842b52a.svg";